import IconEducator from '@/components/icons/educator.vue'
import IconDualEducator from '@/components/icons/dualEducator.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'

export default {
    name: "ServiceHowManyEducators",
    components: {
        IconBase,
        IconEducator,
        IconDualEducator,
        IconArrowBack,
        IconCheck,
        IconForward
    },
    data: () => ({
        number_of_educators: "",
        educator_id: "",
        allfieldsvalid: false
    }),
    methods: {
        Next() {
            //this.$router.push({name:'ServicePreviousPolicies'});
            if(this.number_of_educators != "") {
                this.$parent.ServiceInsuranceProcess.number_of_educators = this.number_of_educators;
                this.$parent.ServiceInsuranceProcess.educator_id = this.educator_id;
                this.$parent.ServiceNextStep(3,"ServicePreviousPolicies");
                
            }
        },
        SelectOption(_element, _option, _educator_id) {
            /*======================================

            function:  
            ► calls function RemoveClassFrom
            ► add selected state to the clicked package
            ► get the name on selected package
            ► get the policy id on the selected package

            ======================================*/

            //this.package_id = _policy_id;
            this.number_of_educators = _option;
            this.educator_id = _educator_id;
            this.package_id_element = _element;
            this.$parent.RemoveClassFrom('selector-item','selected');/* this method can be found in app.vue */
            this.$parent.RemoveClassFrom('check-container','showme');
            this.$parent.AddClassFrom('check-container','hideme');
            this.addSelected(_element);
            this.allfieldsvalid = true;
            //this.$parent.EnableNextButton();
            
            /*======================================
            Note:
            this is how you access parent element:
            this.$parent.TestVariable = "Woah!!!"
            ======================================*/
        },
        addSelected(_element) {
            var check_element = _element + '_check';
            document.getElementById(_element).classList.add("selected");
            document.getElementById(check_element).classList.add("showme");
            document.getElementById(check_element).classList.remove("hideme");
        },
        ValidateSessionData() {
            let _educators = this.$parent.ServiceInsuranceProcess.number_of_educators;
            
            switch (_educators) {
                case "0 - 50": { document.getElementById("educators_option1").click(); this.allfieldsvalid = true; break; }
                case "51 - 100": { document.getElementById("educators_option2").click(); this.allfieldsvalid = true; break; }
                case "Over 100": { document.getElementById("educators_option3").click(); this.allfieldsvalid = true; break; }
                default: { break; }
            } 
        }
    },
    computed: {
        AllFieldsValid: function() {
            return this.allfieldsvalid;
        }   
    },
    mounted() {
        this.ValidateSessionData();
        this.$parent.CheckWindowPathName();
        this.$parent.CurrentProcess = "ServiceInsuranceProcess";
    }
}